import { VERSION } from '@angular/core';

/** The part of the New Relic Browser agent this file uses. */
interface NewRelicBrowserAgent {
  setCustomAttribute(name: string, value: string): void;
}

/**
 * Tags every New Relic Browser event with the running Angular version (feature 024, research R9), so JavaScript
 * errors and page load can be compared per version after each upgrade hop.
 *
 * The agent is loaded inline only in the QA, demo and production index pages; anywhere else `window.newrelic` is
 * undefined and this does nothing. It never throws: a failure here must not stop the portal from starting.
 */
export function setNewRelicAngularVersion(
  target: { newrelic?: NewRelicBrowserAgent } = window as never,
  version: string = VERSION.full
): void {
  try {
    target.newrelic?.setCustomAttribute('angularVersion', version);
  } catch {
    // The attribute is diagnostic only.
  }
}
